import { createContext, useContext } from 'react';
import { parseSiteConfig, type SiteConfig } from '../lib/siteConfig';

export interface SiteModeState {
  config: SiteConfig;
}

/** Without a provider (tests, storybook-style renders) the site is open. */
export const SiteModeContext = createContext<SiteModeState>({
  config: parseSiteConfig({ site_mode: 'live' }),
});

export function useSiteMode(): SiteModeState {
  return useContext(SiteModeContext);
}

/** Where each gated mode lives; every other path redirects there (D32). */
export const GATE_PATHS = { countdown: '/coming-soon', maintenance: '/maintenance' } as const;

/** Handler for links in auth emails. Open in every site mode so an email link never dead-ends (D34). */
export const AUTH_ACTION_PATH = '/auth/action';
